import actionTypes from 'SRC/modules/redux/actionTypes'

export const updateAdById = (id, fields) => ({
  type: actionTypes.UPDATE_AD_BY_ID,
  payload: {id, fields}
})
